import { render, staticRenderFns } from "./OptimizationOverviewCard.vue?vue&type=template&id=1bf9bfdc&scoped=true&lang=pug&"
import script from "./OptimizationOverviewCard.vue?vue&type=script&lang=ts&"
export * from "./OptimizationOverviewCard.vue?vue&type=script&lang=ts&"
import style0 from "./OptimizationOverviewCard.vue?vue&type=style&index=0&id=1bf9bfdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9bfdc",
  null
  
)

export default component.exports